<script>
    import Spinner from 'svelte-spinner';
    import { Tooltip } from "sveltestrap";
    import * as Gauge from "chartjs-gauge";
    
    import { vptServer, token } from '../../stores.js';   
    
    export let id;
    export let todaysConfig;
    export let selectedInmateAspect;

    let chart;
    let riskFactorRecord;
    
    $: {
        if (todaysConfig && todaysConfig.riskFactorChecklistUrn) {
            riskFactorRecord = null;
            getRiskFactorRecordAndRenderChart();
        }
    }

    async function getRiskFactorRecordAndRenderChart() {
        await fetch(`${$vptServer}/inmate/${id}/riskfactor/overview`, {
            headers: {
                "Authorization": "Bearer " + $token
            }
        })
        .then(r => {
            if (!r.ok) {
                throw Error(r.status);
            }
            return r;
        })
        .then(r => r.json())
        .then(data => {
            riskFactorRecord = data;
        })
        .catch(error => {
            console.error("Error getting inmate risk factor overview");
            console.error(error);
            return;
        });

        renderRiskFactorsChart();
    }

    function renderRiskFactorsChart() {
        if (riskFactorRecord && riskFactorRecord.dateLastUpdated) {
            var ctx = document.getElementById("risk-factor-chart-canvas").getContext("2d");
            chart = new Chart(ctx, {
                type: 'gauge',
                data: {
                    labels: ['Low', 'Medium', 'High'],
                    datasets: [{
                        value: riskFactorRecord.weightedPercentage,
                        minValue: 0,
                        data: [todaysConfig.riskFactorPercentageThresholdMedium, todaysConfig.riskFactorPercentageThresholdHigh, 100],
                        backgroundColor: ['#ffe15d', '#FFA500', '#dc3545'],
                    }]
                },
                options: {
                    needle: {
                        radiusPercentage: 2,
                        widthPercentage: 3.2,
                        lengthPercentage: 100,
                        color: 'rgb(33, 37, 41)'
                    },
                    valueLabel: {
                        display: true,
                        formatter: (value) => {
                            return Math.round(value) + '%';
                        },
                        color: 'rgba(255, 255, 255, 1)',
                        backgroundColor: 'rgb(33, 37, 41)',
                        borderRadius: 5,
                        padding: {
                            top: 2,
                            bottom: 2
                        },
                        fontSize: 12
                    },
                    tooltips: {
                        enabled: true,
                        legend: true
                    }
                }
            });
        }
    }
</script>

<style>
    .inmate-widget {
        width: 165px;
    }

    .widget-content {
        flex-direction: column;
        align-items: center;
    }

    .inmate-widget .no-records-container {
        display: flex;
        flex-direction: column;
    }

    .inmate-widget .no-records {
        padding: 0 10px 0 10px;
    }

    .factor-counts {
        padding: 2px 0 0 0;
        align-items: center;
        display: flex;
        flex-direction: column;
    }

    .factor-counts span {
        padding: 3px 0 0 0;
    }
    
    .chart-widget {
        height: auto;
    }

    .factor-counts span.reduced-text {
        font-size: 11px;
    }

    .sig-count-text {
        font-size:12px;
        color: #dc3545;
    }
</style>
{#if todaysConfig && todaysConfig.riskFactorChecklistUrn}
    <div class="inmate-widget">
        {#if riskFactorRecord}
            <button class="button-reset focus-outline card" on:click class:selected={selectedInmateAspect === todaysConfig.riskFactorLabelName}>
                <div class="card-body">
                    <div class="widget-container">
                        <span id="risk-factor-widget-header" class="widget-label" class:widget-label-targeted={riskFactorRecord.indicatorTargeted}>
                            {#if riskFactorRecord.indicatorTargeted}
                                <img id="targeted-indicator-risk-factors" src="/assets/target-indicator.svg" alt="Targeted on the {todaysConfig.riskFactorLabelName} aspect" />
                                <Tooltip target="targeted-indicator-risk-factors" placement="bottom">Targeted on the {todaysConfig.riskFactorLabelName} aspect</Tooltip>
                            {/if}
                            {todaysConfig.riskFactorLabelName}
                        </span>

                        <div class="widget-content">
                            {#if riskFactorRecord.dateLastUpdated} 
                                <div class="chart-label-widget">
                                    <div class="chart-widget">
                                        <canvas id="risk-factor-chart-canvas"></canvas>
                                    </div>
                                </div>
                                <div class="factor-counts">
                                    {#if riskFactorRecord.significantFactorCount > 0}
                                        <span id="risk-factors-detail-sig-factor-count" class="sig-count-text">
                                            {riskFactorRecord.significantFactorCount} Highly Significant
                                        </span>
                                    {/if}
                                    {#if riskFactorRecord.activeFactorCount > 0}
                                        <span id="risk-factors-detail-factor-count" class="reduced-text">
                                            {riskFactorRecord.activeFactorCount} Active
                                        </span>
                                    {/if}
                                </div>
                            {:else}
                                <div class="no-records-container">
                                    <span class="no-records">No {todaysConfig.riskFactorLabelName} assessments have been completed.</span>
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>
            </button>
        {:else}
            <div class="card" class:selected={selectedInmateAspect === todaysConfig.riskFactorLabelName}>
                <div class="card-body">
                    <div class="widget-container">  
                        <div class="widget-spinner">
                            <Spinner size="100" speed="750" color="#3d5980" thickness="3" gap="15" />
                        </div>
                    </div>
                </div>
            </div>
        {/if}
    </div>
{/if}